import { api, getErrorMessage } from '../lib/axios';

export interface OperationManagerUser {
  id: string;
  email: string;
  fullName: string;
  phone: string | null;
  status: string;
  createdAt: string;
}

export interface OperationManagerCreator {
  id: string;
  email: string;
  fullName: string;
}

export interface OperationManager {
  id: string;
  status: 'active' | 'inactive';
  createdAt: string;
  updatedAt: string;
  user: OperationManagerUser;
  createdBy: OperationManagerCreator;
}

export interface CreateOperationManagerInput {
  email: string;
  fullName: string;
  phone?: string;
}

class OperationManagerService {
  async list(): Promise<{ success: boolean; data?: OperationManager[]; error?: string }> {
    try {
      const response = await api.get('/operation-managers');
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error),
      };
    }
  }

  async create(
    input: CreateOperationManagerInput
  ): Promise<{
    success: boolean;
    operationManager?: OperationManager;
    tempPassword?: string | null;
    emailSent?: boolean;
    error?: string;
  }> {
    try {
      const response = await api.post('/operation-managers', input);
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error),
      };
    }
  }

  async updateStatus(
    operationManagerId: string,
    status: 'active' | 'inactive'
  ): Promise<{ success: boolean; operationManager?: OperationManager; error?: string }> {
    try {
      const response = await api.patch(`/operation-managers/${operationManagerId}/status`, { status });
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error),
      };
    }
  }

  async resetPassword(
    operationManagerId: string
  ): Promise<{ success: boolean; tempPassword?: string; emailSent?: boolean; error?: string }> {
    try {
      const response = await api.post(`/operation-managers/${operationManagerId}/reset-password`);
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error),
      };
    }
  }
}

export const operationManagerService = new OperationManagerService();
